import { render } from "./TestimonialSection.vue?vue&type=template&id=140ff3cd&scoped=true"
import script from "./TestimonialSection.vue?vue&type=script&lang=js"
export * from "./TestimonialSection.vue?vue&type=script&lang=js"

import "./TestimonialSection.vue?vue&type=style&index=0&id=140ff3cd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140ff3cd"]])

export default __exports__